import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { FormsModule } from '@angular/forms'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { CalendarModule } from 'primeng/components/calendar/calendar'
import { TextMaskModule } from 'angular2-text-mask'
import { MarkdownModule } from 'ngx-markdown';

import { SelectFieldComponent } from 'app/shared/select-field/select.component'
import { InfoPopupComponent } from './info-popup/info-popup.component'
import { Popup2Component } from './popup2/popup2.component'

// Module for dfds shared ui components
@NgModule({
    imports: [
        CommonModule, RouterModule, BrowserAnimationsModule, CalendarModule, FormsModule, TextMaskModule,
        MarkdownModule.forRoot(),
    ],
    declarations: [
        SelectFieldComponent,
        InfoPopupComponent,
        Popup2Component
    ],
    exports: [
        SelectFieldComponent,
        InfoPopupComponent,
        Popup2Component
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class DFDSUIModule {
}
